export default "__VITE_ASSET__FoTa2bqY__"